import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FormModule } from '@lib/form';
import { PosthogService } from '@lib/services';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { CoreModule } from './core/core.module';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ButtonModule, DrawerModule, FormModule, CoreModule],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'members';
  visible: boolean = false;

  constructor(private posthogService: PosthogService) {}
}
